// material-ui
import { useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

// project import
import { drawerWidth } from 'config';

const minDrawerWidth = 60;
const maxDrawerWidth = drawerWidth;

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden',
  boxShadow: 'none'
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  width: `calc(${theme.spacing(7)} + 1px)`,
  // [theme.breakpoints.up('sm')]: {
  //   width: `calc(${theme.spacing(8)} + 1px)`
  // },
  borderRight: `1px solid ${theme.palette.divider}`,
  // boxShadow: theme.customShadows.z1
  overflowX: 'hidden',
  boxShadow: 'none'
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  minWidth: `calc(${theme.spacing(7)} + 1px)`,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

// const ResizableSidebar = ({ children }) => {
//   const [drawerWidth, setDrawerWidth] = useState(240);
//   const [isDragging, setIsDragging] = useState(false);
//   const sidebarRef = useRef(null);

//   const handleMouseDown = () => {
//     setIsDragging(true);
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handleMouseMove = (event) => {
//     if (!isDragging) return;
//     const newWidth = Math.min(maxDrawerWidth, Math.max(minDrawerWidth, event.clientX));
//     setDrawerWidth(newWidth);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener('mousemove', handleMouseMove);
//       document.addEventListener('mouseup', handleMouseUp);
//     } else {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//     };
//   }, [isDragging]);

//   return (
//     <Box sx={{ display: 'flex', width: '100%' }}>
//       <MiniDrawerStyled
//         variant="permanent"
//         open={drawerWidth > minDrawerWidth}
//         PaperProps={{ style: { width: drawerWidth } }}
//         ref={sidebarRef}
//       >
//         {/* Sidebar content here */}
//         {children}
//       </MiniDrawerStyled>
//       <button
//         style={{
//           width: '5px',
//           cursor: 'col-resize',
//           height: '100vh',
//           backgroundColor: '#ccc'
//         }}
//         onMouseDown={handleMouseDown}
//       />
//       {/* Main content here */}
//     </Box>
//   );
// };

// export default ResizableSidebar;

export default MiniDrawerStyled;
